import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, className = "", y = 36 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ overline, title, testId }) {
  return (
    <div className="mb-14 sm:mb-20">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-ember font-mono mb-5 flex items-center gap-3">
          <span className="inline-block h-px w-10 bg-ember" aria-hidden="true" />
          {overline}
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2
          data-testid={testId}
          className="font-display font-bold tracking-tight leading-[1.05] text-3xl sm:text-4xl lg:text-5xl max-w-3xl text-ink"
        >
          {title}
        </h2>
      </Reveal>
    </div>
  );
}

export function MaskedLine({ children, delay = 0, as: Tag = "span", className = "" }) {
  return (
    <Tag className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "115%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </Tag>
  );
}
